import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICapexCriticalLevel, ICapexCriticalLevelsByYear, ICriticalLevel } from './interfaces';

export const getCapexCriticalLevelList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICapexCriticalLevel[]>('/capexCriticalLevel/list', data)
    .then((response) => response.data);
};

export const getCapexCriticalLevelListAll = () => {
  return instance()
    .post<ICapexCriticalLevel[]>('/capexCriticalLevel/listAllCapexCriticalLevel')
    .then((response) => response.data);
};

export const getCapexCriticalLevelAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/capexCriticalLevel/availableColumns')
    .then((response) => response.data);
};

export const getCapexCriticalLevelAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/capexCriticalLevel/availableGroupColumns')
    .then((response) => response.data);
};

export const loadCapexCriticalLevel = (year: number) => {
  return instance()
    .get<ICapexCriticalLevelsByYear>(`/capexCriticalLevel/load/${year}`)
    .then((response) => response.data);
};

export const createCapexCriticalLevel = (criticalLevel: ICapexCriticalLevelsByYear) => {
  return instance()
    .post<ICapexCriticalLevel>(`/capexCriticalLevel/save`, criticalLevel)
    .then((response) => response.data);
};

export const updateCapexCriticalLevel = (criticalLevel: ICapexCriticalLevelsByYear) => {
  return instance()
    .post<ICapexCriticalLevel>(`/capexCriticalLevel/update`, criticalLevel)
    .then((response) => response.data);
};

export const archiveCapexCriticalLevel = (capexCriticalLevelId: number) => {
  return instance()
    .post(`/capexCriticalLevel/archive`, { capexCriticalLevelId })
    .then((response) => response.data);
};

export const recoverCapexCriticalLevel = (capexCriticalLevelId: number) => {
  return instance()
    .post(`/capexCriticalLevel/recover`, { capexCriticalLevelId })
    .then((response) => response.data);
};

export const getCriticalLevels = (config?: AxiosRequestConfig) => {
  return instance()
    .post<ICriticalLevel[]>('/checklist/level', {}, config)
    .then((response) =>
      response.data.map(({ levelId, levelName }) => ({ criticalLevelId: levelId, criticalLevelName: levelName })),
    );
};
